module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_2.93162451.png";